// extracted by mini-css-extract-plugin
export default {"utilizationItem":"utilization_item-module___utilizationItem___affbf724","label":"utilization_item-module___label___e51bd7a6"};